import { ActionType, ScopeTypes } from "api/models/authServiceModels";
import { Navigate, Route, Routes } from "react-router-dom";

import { getIsAuthenticated } from "atoms/auth";
import { useRecoilValue } from "recoil";
import useUserInfo from "hooks/useUserInfo";

interface AuthedRouteProps {
  children: JSX.Element;
}

interface PrivateRouteProps extends AuthedRouteProps {
  scope: ScopeTypes;
  action: ActionType;
}

export const AuthedRoute = ({ children }: AuthedRouteProps) => {
  const isAuth = useRecoilValue(getIsAuthenticated);

  if (isAuth) {
    return <>{children}</>;
  }

  return (
    <Routes>
      <Route element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export const PrivateRoute = ({
  scope,
  action,
  children
}: PrivateRouteProps) => {
  const { permissions } = useUserInfo();

  if (permissions) {
    // If the route requires permissions we check them before returning the content
    if (permissions[scope].some(ac => ac === action)) {
      return <>{children}</>;
    }
    // If you are logged in but lack permissions, redirect to an unauthorized page, letting us know where you came from
    return (
      <Routes>
        <Route element={<Navigate to={`/login`} replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
